import { render, staticRenderFns } from "./RelocationsMapPage.vue?vue&type=template&id=1ae26c88&"
import script from "./RelocationsMapPage.vue?vue&type=script&lang=ts&"
export * from "./RelocationsMapPage.vue?vue&type=script&lang=ts&"
import style0 from "./RelocationsMapPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports